import React from 'react';
import loc from 'owa-localize';
import { PivotItem } from '@fluentui/react/lib/Pivot';
import { getDensityModeCssClass } from 'owa-fabric-theme';
import type { IPivotItemProps } from '@fluentui/react/lib/Pivot';
import { priorityViewFilterText } from './PriorityInboxPivot.locstring.json';
import classnames from 'owa-classnames';
import { full, medium, compact, pivotItem, pivotItemContainer } from './InboxPivotStyles.scss';
import PriorityPivotTip from './PriorityPivotTip';

export function renderPriorityPivot(): JSX.Element {
    return (
        <PivotItem
            headerText={loc(priorityViewFilterText)}
            itemKey={'priority'}
            onRenderItemLink={onRenderItemLinkHandler}
        />
    );
}

const onRenderItemLinkHandler = (
    pivotProps?: IPivotItemProps,
    defaultRender?: (props?: IPivotItemProps) => JSX.Element | null
): JSX.Element | null => {
    const densityModeCssClass = getDensityModeCssClass(full, medium, compact);

    return pivotProps && defaultRender ? (
        <>
            <div id={'priorityTabInbox'} className={classnames(pivotItem, densityModeCssClass)}>
                <div className={classnames(pivotItemContainer, densityModeCssClass)}>
                    {defaultRender(pivotProps)}
                </div>
            </div>
            <PriorityPivotTip id="PriorityPivot" target="#priorityTabInbox" />
        </>
    ) : null;
};
